module.exports = __webpack_public_path__ + "static/img/left-bottom-row-1.6902bfae.png";